import { render, staticRenderFns } from "./sameproduct.vue?vue&type=template&id=26c3cef0&scoped=true"
import script from "./sameproduct.vue?vue&type=script&lang=js"
export * from "./sameproduct.vue?vue&type=script&lang=js"
import style0 from "./sameproduct.vue?vue&type=style&index=0&id=26c3cef0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c3cef0",
  null
  
)

export default component.exports